import { useEffect } from "react";
import Lenis from "lenis";
import { AudioProvider } from "@/context/AudioContext";
import Header from "@/components/afr/Header";
import Hero from "@/components/afr/Hero";
import Marquee from "@/components/afr/Marquee";
import Catalog from "@/components/afr/Catalog";
import About from "@/components/afr/About";
import TrackRecord from "@/components/afr/TrackRecord";
import Artists from "@/components/afr/Artists";
import Contact from "@/components/afr/Contact";
import Footer from "@/components/afr/Footer";
import AudioDock from "@/components/afr/AudioDock";

export default function MarketingSite() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <AudioProvider>
      <div className="App bg-white text-black antialiased overflow-x-hidden">
        <Header />
        <main>
          <Hero />
          <Marquee />
          <Catalog />
          <About />
          <TrackRecord />
          <Artists />
          <Contact />
          <Footer />
        </main>
        <AudioDock />
      </div>
    </AudioProvider>
  );
}
